import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import s from './ModelServicePlan.module.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import ModelServicePlan from './ModelServicePlan';
import moment from 'moment-timezone';

const ModelServicePlanListTable = ({
  setEditHandler,
  ModelCategoryId,
  ModelId,
  selectedModelServicePlanId,
  saveModelServicePlan,
  modelServicePlans,
  describeModelServicePlan,
  changeModelServicePlan,
  checklistTemplate,
  paginatedData = [],
  UpdateAllowed,
  ReadOnly,
  disableMode,
  disableModeHandler,
  isModelCategoryOwner,
  addNewRef,
  intl,
  currentTimezone
}) => {
  const fetchDataHandler = modelServicePlanId => {
    setEditHandler(modelServicePlanId);
    disableModeHandler(true);
    describeModelServicePlan(ModelCategoryId, ModelId, modelServicePlanId);
  };

  const cancelHandler = () => {
    setEditHandler(-1);
    disableModeHandler(false);
  };

  const editModelContent = (
    <ModelServicePlan
      ModelServicePlanId={selectedModelServicePlanId}
      ModelCategoryId={ModelCategoryId}
      ModelId={ModelId}
      saveModelServicePlan={saveModelServicePlan}
      describeModelServicePlan={describeModelServicePlan}
      modelServicePlan={modelServicePlans}
      changeModelServicePlan={changeModelServicePlan}
      checklistTemplate={checklistTemplate}
      cancelHandler={cancelHandler}
      currentTimezone={currentTimezone}
      setEditHandler={setEditHandler}
    />
  );

  let editorMain = (
    <tr>
      <td colSpan="10">{editModelContent}</td>
    </tr>
  );

  let newRowClass = modelServicePlans.showAddEditScreen && selectedModelServicePlanId === 0 ? s.newRow : '';

  return (
    <div className={s.wsTableContainer}>
      <Table variant className={s.wsTable}>
        <thead>
          <tr>
            <th>
              <FormattedMessage id="modelServicePlan.name" defaultMessage="Name" />
            </th>
            <th>
              <FormattedMessage id="modelServicePlan.description" defaultMessage="Description" />
            </th>
            <th>
              <FormattedMessage id="modelServicePlan.checklistName" defaultMessage="Checklist Template" />
            </th>
            <th>
              <FormattedMessage id="modelServicePlan.startDateTime" defaultMessage="Start Date" />
            </th>
            <th>
              <FormattedMessage id="modelServicePlan.scheduleEvery" defaultMessage="Schedule Every" />
            </th>
            <th>
              <FormattedMessage id="modelServicePlan.scheduleByPeriod" defaultMessage="Schedule Period" />
            </th>

            {!ReadOnly && UpdateAllowed && isModelCategoryOwner && <th></th>}
          </tr>
        </thead>
        <tbody>
          {paginatedData.map(n => {
            return (
              <Fragment key={n.ModelServicePlanId}>
                <tr key={n.ModelServicePlanId} data-unittest="paginatedData">
                  <td>{n.Name}</td>
                  <td>{n.Description}</td>
                  <td>{n.ChecklistName}</td>
                  <td>
                    {n.StartDateTime
                      ? moment
                        .unix(parseInt(n.StartDateTime))
                        .tz(currentTimezone)
                        .format('DD-MMM-YYYY HH:mm:ss z')
                      : '-'}
                  </td>
                  <td>{n.ScheduleBy}</td>
                  <td>{n.ScheduleByPeriod}</td>
                  {!ReadOnly && UpdateAllowed && isModelCategoryOwner && (
                    <td className={s.btnCol}>
                      {UpdateAllowed && (
                        <Button
                          variant="outline-secondary"
                          className={s.changeButton}
                          href="#"
                          onClick={fetchDataHandler.bind(this, n.ModelServicePlanId)}
                          disabled={disableMode}
                          data-unittest="changeData"
                        >
                          <FormattedMessage id="common.ledit" defaultMessage="Edit" />
                        </Button>
                      )}
                    </td>
                  )}
                </tr>
                {modelServicePlans.showAddEditScreen &&
                  selectedModelServicePlanId === n.ModelServicePlanId &&
                  editorMain}
              </Fragment>
            );
          })}
        </tbody>
      </Table>
      <div className={newRowClass} ref={addNewRef}>
        {modelServicePlans.showAddEditScreen && selectedModelServicePlanId === 0 && editModelContent}
      </div>
    </div>
  );
};

ModelServicePlanListTable.propTypes = {
  setEditHandler: PropTypes.func.isRequired,
  selectedModelServicePlanId: PropTypes.number,
  saveModelServicePlan: PropTypes.func.isRequired,
  modelServicePlans: PropTypes.object.isRequired,
  describeModelServicePlan: PropTypes.func.isRequired,
  changeModelServicePlan: PropTypes.func.isRequired,
  checklistTemplate: PropTypes.object.isRequired,
  paginatedData: PropTypes.array,
  UpdateAllowed: PropTypes.bool,
  disableMode: PropTypes.bool,
  disableModeHandler: PropTypes.func.isRequired
};

export default injectIntl(ModelServicePlanListTable);
